module.exports = __webpack_public_path__ + "img/stas-main.f5511618.webp";